import {Breadcrumbs, CircularProgress, Divider, Grid, Typography} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import PageTitle from '../../../common/PageTitle';
import { SettingsIcon } from '../../../common/Icons';
import LinkNavegacao from '../../../common/Link';
import CardOption from '../../../common/CardOption';
import React, {useEffect, useState} from "react";
import {verifyUserAbilities} from "../../../config/functions";

function Settings() {
    const [abilities, setAbilities] = useState({});
    const [loading, setLoading] = useState(true);

    const permissoesBlocos = [
        {
            titulo: "Geral",
            permissoes: [
                { rota: "configEmpresa", title: "Configuração de Termos para Documentos de EPI", description: "Configure as informações dos seus documentos", url: "configuracao-empresa" },
            ]
        },
        {
            titulo: "Integrações",
            permissoes: [
                { rota: "empresas", title: "Integrações", description: "Configure a integração dos seus dados com sistemas externos", url: "integracao" },
            ]
        },
        {
            titulo: "Exportações",
            permissoes: [
                { rota: "exportacao", title: "Exportações", description: "Exporte seus dados para alimentar outros sistemas", url: "exportacao" },
                { rota: "tiposExportacao", title: "Configurações de Exportação", description: "Configure o formato de exportação dos dados de sua preferência", url: "configuracoes-exportacao" },
            ]
        }
    ];

    useEffect(() => {
        const carregarPermissoes = async () => {
            const todasPermissoes = permissoesBlocos.flatMap(bloco => bloco.permissoes);
            const resultados = {};

            await Promise.all(todasPermissoes.map(async (item) => {
                resultados[item.rota] = await verifyUserAbilities({ rota: item.rota });
            }));

            setAbilities(resultados);
            setLoading(false);
        };

        carregarPermissoes();
    }, []);

    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ height: "100vh" }}>
                <CircularProgress />
            </Grid>
        );
    }

    const renderBloco = (titulo, permissoes) => (
        <>
            <Grid item xs={12}>
                <Typography variant='h6' mt={1}>
                    {titulo}
                    <Divider />
                </Typography>
            </Grid>
            {permissoes.map(item => {
                const temPermissao = abilities[item.rota]?.data.success;
                return (
                    <Grid
                        key={item.rota}
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        xl={3}
                        sx={{
                            opacity: temPermissao ? 1 : 0.5,
                            pointerEvents: temPermissao ? 'auto' : 'none',
                        }}
                    >
                        <CardOption
                            title={item.title}
                            description={item.description}
                            url={item.url}
                            hasPermisson={temPermissao}
                            sx={{
                                backgroundColor: temPermissao ? 'transparent' : 'gray',
                                color: temPermissao ? 'black' : 'gray',
                            }}
                        />
                    </Grid>
                )
            })}
        </>
    );

    return (
        <>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="stretch"
                spacing={3}

            >
                <Grid item xs={12}>
                    <Breadcrumbs>
                        <LinkNavegacao to='/'><HomeIcon fontSize='small' /></LinkNavegacao>
                        <Typography variant='span'>Gerenciamento</Typography>
                        <Typography variant='span'>Configurações</Typography>
                    </Breadcrumbs>
                    <PageTitle icon={<SettingsIcon fontSize='large' />} title={'Configurações'} />
                </Grid>

                {permissoesBlocos.map((bloco, idx) => (
                <React.Fragment key={idx}>
                    {renderBloco(bloco.titulo, bloco.permissoes)}
                </React.Fragment>
                ))}
            </Grid>
        </>
    );
}

export default Settings;